import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AdminTable from 'common/AdminTable';
import { getOrderListDB, updateOrderListDB } from 'slice/orderSliceDB';
import Select from 'react-select';
// import axios from 'axios';
import { io } from "socket.io-client";
import { getRequest } from 'apis/ApiInstence';
// import { useNavigate } from 'react-router-dom';

const socket = io(process.env.REACT_APP_BACKEND)

const CorderList = () => {
    const dispatch = useDispatch();
    const cartData = useSelector((state) => state.orderDB);
    // const navigator = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [isToday, setIsToday] = useState(true);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [orderData, setOrderData] = useState([])

    // Service men state
    const [serviceMen, setServiceMen] = useState([]);
    const [selectedServiceMan, setSelectedServiceMan] = useState(null);

    useEffect(() => {
        isToday ? dispatch(getOrderListDB({ id: 'today' })) : dispatch(getOrderListDB({ id: '7days' }));
    }, [dispatch, isToday]);

    // Fetch servicemen when modal opens with a city
    useEffect(() => {
        if (showModal && currentProduct?.city) {
            fetchServiceMen(currentProduct.city);
        }
    }, [showModal, currentProduct]);

    const fetchServiceMen = async (city) => {
        try {
            const { data } = await getRequest(`servicemen?city=${city}&status=active`);
            setServiceMen(data || []);
        } catch (error) {
            console.error("Error fetching servicemen:", error);
        }
    };

    const handleEditClick = (product) => {
        fetchOrderDetails(product?.order_id)
        setCurrentProduct(product);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
        setServiceMen([]);
        setSelectedServiceMan(null);
    };

    useEffect(() => {
        socket.on("new-payment", (data) => {
            console.log(data)
            isToday ? dispatch(getOrderListDB({ id: 'today' })) : dispatch(getOrderListDB({ id: '7days' }));
        });
        return () => {
            socket.off("new-payment");
        };
    }, []);

    const totalAmount = orderData.reduce((sum, item) => {
        return sum + (item.quantity * item.price);
    }, 0);

    useEffect(() => {
        socket.on("order-update", (data) => {
            console.log(data)
            isToday ? dispatch(getOrderListDB({ id: 'today' })) : dispatch(getOrderListDB({ id: '7days' }));
        });
        return () => {
            socket.off("order-update");
        };
    }, []);

    useEffect(() => {
        if (serviceMen.length && currentProduct?.serviceman_assigned_id) {

            const selected = serviceMen.find(
                sm => sm.id == currentProduct.serviceman_assigned_id
            );

            if (selected) {
                setSelectedServiceMan({
                    value: selected.id,
                    data: selected,
                    label: (
                        <div className="d-flex align-items-center">
                            <img
                                src={`${process.env.REACT_APP_BACKEND}asserts/serviceman/${selected.user_image}`}
                                alt="pic"
                                width={40}
                                height={40}
                                className="rounded-circle mr-2"
                            />
                            <div>
                                <div><strong>{selected.name}</strong></div>
                                <small>{selected.city} | {selected.mobile} | {selected?.service_category}</small>
                            </div>
                        </div>
                    )
                });
            }
        }
    }, [serviceMen, currentProduct]);

    const fetchOrderDetails = async (orderId) => {
        try {
            const { data } = await getRequest(`order/order_details/${orderId}`);
            setOrderData(data?.itemData1)
            return data;
        } catch (error) {
            console.error("Error fetching order details:", error);
            return null;
        }
    };


    const handleSave = () => {
        const updateData = {
            ...currentProduct,
            serviceman_assigned_id: selectedServiceMan ? selectedServiceMan.value : null,
        };
        dispatch(updateOrderListDB({ id: currentProduct.id, data: updateData }));
        handleCloseModal();
    };

    const tableHeaders = [
        { Header: 'Order ID', accessor: 'order_id' },
        {
            Header: 'Payment', accessor: 'payment_method', Cell: ({ row }) => {

                return (
                    row?.original?.payment_method == 'cash' ? <span className='badge bg-success text-white p-2'>CASH</span> : <span className='badge bg-warning text-white p-2 text-uppercase'>{row?.original?.payment_method}</span>
                )

            }
        },
        {
            Header: 'Customer Name',
            accessor: 'customer.name',
            Cell: ({ row }) => (
                <>{row?.original?.customer?.name ? row.original.customer.name.toUpperCase() : ''}</>
            )
        },
        { Header: 'Mobile', accessor: 'phone' },
        { Header: 'City', accessor: 'city' },
        { Header: 'Date', accessor: 'order_date' },
        { Header: 'Time', accessor: 'timing' },
        {
            Header: 'Serviceman Name',
            accessor: 'serviceman.name',
            Cell: ({ row }) => (
                <>{row?.original?.servicemen?.name ? row.original.servicemen.name.toUpperCase() : ''}</>
            )
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => {
                const status = row.original.status || '';
                let bgColor;
                switch (status) {
                    case 'serviceman_pending':
                    case 'pending': bgColor = 'bg-warning'; break;
                    case 'serviceman_accepted':
                    case 'serviceman_start':
                    case 'completed': bgColor = 'bg-success'; break;
                    case 'cancel_by_admin':
                    case 'cancel_by_user':
                    case 'serviceman_reject':
                    case 'cancel_by_service': bgColor = 'bg-danger'; break;
                    default: bgColor = '';
                }
                return (
                    <span className={`badge ${bgColor} text-white p-2 text-uppercase`}>
                        {status ? status.charAt(0).toUpperCase() + status.slice(1) : 'N/A'}
                    </span>
                );
            }
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <button
                    className="btn editbtn mx-1 my-1"
                    onClick={() => handleEditClick(row.original)}
                >
                    <span className='fa fa-eye'></span>
                </button>
            ),
        },
        //    {
        //     Header: 'Tracling',
        //     accessor: 'Tracling',
        //     Cell: ({ row }) => (
        //         <button
        //             className="btn editbtn mx-1 my-1"
        //             onClick={() => navigator(`/tracking/update/${row.original.id}`, { 
        //                 state: { 
        //                     order: row.original,
        //                     address: row.original.shipping_address,
        //                     city: row.original.city
        //                 } 
        //             })}
        //         >
        //             <span className='fa fa-eye'></span>
        //         </button>
        //     ),
        // },
    ];

    return (
        <>
            <div className="container-fluid mt-5">
                <div className="mainheadig mx-4 d-flex">
                    <h4 className="text-white font-weight-bold">Customer {isToday ? "Today" : "All"} Orders</h4>
                    <button
                        className="ml-auto btn btn-primary mr-4"
                        onClick={() => setIsToday(!isToday)}
                    >
                        {isToday ? "All" : "Today"}
                    </button>
                </div>

                {cartData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : <div className='bg-danger p-2 mx-4 text-white'> No Order found !!!</div>}
            </div>

            {/* Edit Modal */}
            {showModal && currentProduct && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assign Order</h5>
                                <button type="button" className="close" onClick={handleCloseModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                                <form>
                                    {/* ORDER DETAILS HEADER */}
                                    <div className="container-fluid mb-3 p-3 bg-light rounded">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <strong>Order ID:</strong>
                                                <div>{currentProduct.order_id}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <strong>Customer:</strong>
                                                <div>{currentProduct?.customer?.name}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <strong>Mobile:</strong>
                                                <div>{currentProduct.phone}</div>
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <strong>City:</strong>
                                                <div>{currentProduct.city}</div>
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <strong>Date:</strong>
                                                <div>{currentProduct.createdAt}</div>
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <strong>Total Amount:</strong>
                                                <div>₹ {currentProduct.total_amount}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {orderData?.length > 0 && (
                                        <div className="table-responsive mt-3">
                                            <table className="table table-bordered">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Service</th>
                                                        <th className="text-center">Qty</th>
                                                        <th className="text-right">Rate (₹)</th>
                                                        <th className="text-right">Amount (₹)</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {orderData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item?.products.name}</td>
                                                            <td className="text-center">{item.quantity}</td>
                                                            <td className="text-right">{item.price}</td>
                                                            <td className="text-right">
                                                                {item.quantity * item.price}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    <tr className="font-weight-bold bg-light">
                                                        <td colSpan="4" className="text-right">
                                                            Total
                                                        </td>
                                                        <td className="text-right">
                                                            ₹ {totalAmount}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {/* Status Select */}
                                    <div className='container-fluid'>
                                        <div className='row'>

                                            <div className='col-sm-6'>
                                                <div className="form-group">
                                                    <label htmlFor="status">Status</label>

                                                    {
                                                        currentProduct?.status == 'completed' ? <div className='col-sm-6 text-danger'>Service is completed</div> : <select
                                                            className="form-control"
                                                            value={currentProduct.status}
                                                            onChange={(e) =>
                                                                setCurrentProduct({ ...currentProduct, status: e.target.value })
                                                            }
                                                        >
                                                            <option value="pending">Pending</option>
                                                            <option value="serviceman_pending">Assigned</option>
                                                            <option value="serviceman_accepted">Assigned Accepted</option>
                                                            <option value="completed">Completed</option>
                                                            <option value="cancel_by_admin">Cancel by Admin</option>
                                                            <option value="cancel_by_user">Cancel by User</option>
                                                            <option value="cancel_by_service">Cancel by Service</option>
                                                        </select>
                                                    }

                                                </div>
                                            </div>
                                            <div className='col-sm-6'>
                                                <div className="form-group">
                                                    <label htmlFor="status">City</label>
                                                    <select
                                                        className="form-control"
                                                        value={currentProduct?.city}
                                                        onChange={(e) =>
                                                            setCurrentProduct({ ...currentProduct, city: e.target.value })
                                                        }
                                                    >
                                                        <option value="">Select City</option>
                                                        <option value="Jabalpur">Jabalpur</option>
                                                        <option value="Bhopal">Bhopal</option>
                                                        <option value="Indore">Indore</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className='col-sm-6'>
                                                {
                                                    currentProduct?.shipping_address && <div className='my-3'>
                                                        <label htmlFor="address">Address</label>
                                                        <textarea id='address' value={currentProduct?.shipping_address} rows={5} className='form-control'></textarea>
                                                    </div>
                                                }
                                            </div>

                                            <div className='col-sm-6 my-3'>
                                                {
                                                    currentProduct?.message && <>
                                                        <label htmlFor="message">Message</label>
                                                        <textarea id='message' className='form-control' value={currentProduct?.message} rows={5}></textarea>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {/* Serviceman Assignment */}

                                    {
                                        currentProduct?.status == 'completed' ? "" : <div className="form-group">
                                            <label>Assign Serviceman (City: {currentProduct.city})</label>
                                            <Select
                                                options={serviceMen.map(sm => ({
                                                    value: sm.id,
                                                    label: (
                                                        <div className="d-flex align-items-center">
                                                            <img
                                                                src={`${process.env.REACT_APP_BACKEND}asserts/serviceman/${sm.user_image}`}
                                                                alt="pic"
                                                                width={40}
                                                                height={40}
                                                                className="rounded-circle mr-2"
                                                            />
                                                            <div>
                                                                <div><strong>{sm.name}</strong></div>
                                                                <small>{sm.city} | {sm.mobile} | {sm?.service_category}</small>
                                                            </div>
                                                        </div>
                                                    )
                                                }))}
                                                value={selectedServiceMan}
                                                onChange={setSelectedServiceMan}
                                                placeholder="Select a serviceman"
                                                isClearable
                                            />
                                        </div>
                                    }


                                    <h5> Before Images </h5>

                                    <div className="d-flex justify-content-between p-2 bg-light flex-wrap">
                                        {
                                            currentProduct?.before_image &&
                                            currentProduct.before_image.split(",").map((data, key) => {
                                                const imgUrl = `${process.env.REACT_APP_BACKEND}uploads/beforeImage/${data}`;

                                                return (
                                                    <div key={key} className="m-2">
                                                        {/* CLICKABLE IMAGE USING BUTTON → NO WARNING */}
                                                        <a
                                                            className="p-0 border-0 bg-transparent"
                                                            style={{ cursor: "pointer" }}
                                                            href={imgUrl}
                                                            target='_blank'
                                                            rel="noreferrer"


                                                        >
                                                            <img
                                                                src={imgUrl}
                                                                alt={data}
                                                                height={100}
                                                                className="rounded"
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>


                                    <h5 className="my-4">After Images</h5>

                                    <div className="d-flex justify-content-between p-2 bg-light flex-wrap">
                                        {
                                            currentProduct?.after_image &&
                                            currentProduct.after_image.split(",").map((data, key) => {
                                                const imgUrl = `${process.env.REACT_APP_BACKEND}uploads/afterImage/${data}`;

                                                return (
                                                    <div key={key} className="m-2">
                                                        {/* CLICKABLE IMAGE USING BUTTON → NO WARNING */}
                                                        <a
                                                            className="p-0 border-0 bg-transparent"
                                                            style={{ cursor: "pointer" }}
                                                            href={imgUrl}
                                                            target='_blank'
                                                            rel="noreferrer"


                                                        >
                                                            <img
                                                                src={imgUrl}
                                                                alt={data}
                                                                height={100}
                                                                className="rounded"
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>



                                    <h5 className="my-4">QR Payment</h5>

                                    <div className="d-flex justify-content-between p-2 bg-light flex-wrap">
                                        {
                                            currentProduct?.slip &&
                                            currentProduct.slip.split(",").map((data, key) => {
                                                const imgUrl = `${process.env.REACT_APP_BACKEND}uploads/paymentSlip/${data}`;

                                                return (
                                                    <div key={key} className="m-2">
                                                        {/* CLICKABLE IMAGE USING BUTTON → NO WARNING */}
                                                        <a
                                                            className="p-0 border-0 bg-transparent"
                                                            style={{ cursor: "pointer" }}
                                                            href={imgUrl}
                                                            target='_blank'
                                                            rel="noreferrer"


                                                        >
                                                            <img
                                                                src={imgUrl}
                                                                alt={data}
                                                                height={100}
                                                                className="rounded"
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>



                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {showImageModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.7)",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%"
                    }}
                >
                    {/* BACKDROP CLICK AREA AS BUTTON */}
                    <button
                        onClick={() => setShowImageModal(true)}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer"
                        }}
                        aria-label="Close image preview"
                    >
                        close data
                    </button>
                </div>
            )}


        </>
    );
};

export default CorderList;
